import 'css-chunksrc/client/scenes/projectReportSubmission/textFieldsForm/styles.scss';export default {
  "textFieldsForm": "_textFieldsForm_1y6x0_1",
  "input": "_input_1y6x0_5",
  "criteriaInput": "_criteriaInput_1y6x0_9",
  "fullWidth": "_fullWidth_1y6x0_9",
  "inline": "_inline_1y6x0_12",
  "subTitle": "_subTitle_1y6x0_20",
  "textarea": "_textarea_1y6x0_26"
};